import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type ProductTag = {
  product_tag_id?: number; // 상품태그 idx
  tag_id?: number; // 태그 idx
  product_id?: number; // 상품 idx
  created_at?: number; // 생성일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] ProductTag
   * --
   */
  getProductTags: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_PRODUCT_TAG, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] ProductTag
   * --
   */
  getProductTag: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_PRODUCT_TAG, {
        product_tag_id: idx,
      });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] ProductTag
   * --
   */
  createProductTag: async (body: ProductTag) => {
    try {
      const res = await $http.post(APIConstant.CREATE_PRODUCT_TAG, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] ProductTag
   * --
   */
  updateProductTag: async (body: ProductTag) => {
    try {
      const { product_tag_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_PRODUCT_TAG, {
        product_tag_id,
      });
      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] ProductTag
   * --
   */
  deleteProductTag: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.DELETE_PRODUCT_TAG, {
        product_tag_id: idx,
      });
      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [CREATE] ProductTag
   * --
   */
  bulkCreateProductTags: async (body: ProductTag[]) => {
    try {
      const res = await $http.post(APIConstant.BULK_CREATE_PRODUCT_TAG, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] ProductTag
   * --
   */
  bulkDeleteProductTags: async (body: ProductTag[]) => {
    try {
      const res = await $http.bulk(
        APIConstant.BULK_DELETE_PRODUCT_TAG,
        body,
        'DELETE'
      );

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
